import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";

//purchase

export async function PurchaseList(params = {}) {
  try {
    const response = await api.get("purchases/purchase-orders/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPurchaseDetails(uuid) {
  try {
    const response = await api.get(`purchases/purchase-orders/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function RfqsList(params = {}) {
  try {
    const response = await api.get("purchases/rfqs/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getRfq(uuid) {
  try {
    const response = await api.get(`purchases/rfqs/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getCustomerSourceOfSupply(customer_id) {
  try {
    const response = await api.get(`customer/${customer_id}/place-of-supply/`);
    return response.data;
  } catch (error) {
    // console.log("Error getting Document",error)
  }
}

export async function AddPurchase(formData) {
  try {
    const response = await api.post("purchases/", formData);
    return response;
  } catch (error) {
    console.log("Error adding driver");
  }
}

export async function CreatePurchaseOrder(formData) {
  try {
    const response = await api.post("purchases/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CreateRFQ(formData) {
  try {
    const response = await api.post("purchases/rfq/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function duplicatePurchaseOrder(purchaseId) {
  const response = await api.post(`purchases/duplicate/?id=${purchaseId}`);
  return response.data;
}

export async function duplicateRfq(purchaseId) {
  const response = await api.post(`purchases/rfq/duplicate/?id=${purchaseId}`);
  return response.data;
}

// export async function PurchaseOrderEdit(id,formData) {
//   try{
//     const response = await api.put(`purchases/?id=${id}`,formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

export async function ConfirmPurchaseOrder(id) {
  try {
    const response = await api.post(`purchases/confirm/${id}/`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

export async function CancelPurchaseOrder(id) {
  try {
    const response = await api.post(`purchases/cancel/${id}/`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

export async function UpdatePurchaseOrder(uuid, formData) {
  try {
    const response = await api.put(`purchases/${uuid}/update/`, formData);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

export async function PurchaseOrderDelete(id) {
  try {
    let response;
    if (Array.isArray(id)) {
      response = await api.delete(`purchases/purchase-orders/delete/?uuid=${id.join(',')}`);
    } else {
      response = await api.delete(`purchases/purchase-orders/${id}/delete/`);
    }
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

// export async function PurchasesAddressList(params={}) {
//   try {

//       const response = await api.get("purchases/address/active",{params});
//       return response;

//   } catch (error) {
//     console.log(error);
//   }
// }

// export async function PurchaseAddressAdd(formData) {
//   try{
//     const response = await api.post('purchases/address/',formData);
//     return response
//   }catch(error){
//     console.log("Error adding driver")
//   }
// }

// export async function PurchaseAddressEdit(id,formData) {
//   try{
//     const response = await api.put(`purchases/address/?id=${id}`,formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// export async function PurchaseProductList(params={}) {
//   try {

//       const response = await api.get("purchases/products/active",{params});
//       return response;

//   } catch (error) {
//     console.log(error);
//   }
// }

// export async function PurchaseProductAdd(formData) {
//   console.log("Data",formData)
//   try{
//     const response = await api.post('purchases/products/',formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// export async function PurchaseProductEdit(id,formData) {
//   console.log(id,formData)
//   try{
//     const response = await api.put(`purchases/products/?id=${id}`,formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// export async function PurchaseProductDelete(id) {
//   try{
//     const response = await api.delete(`purchases/products/?id=${id}`);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

// export async function ArchivePurchase(id){
//   try{
//       const response =await api.get(`purchases/archive?id=${id}`);
//       return response
//   }catch (error) {
//       console.log("Error Archiving Purchase : ", error);
//   }
// }

export async function ArchivePurchase(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("purchases/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`purchases/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

// export async function AddVendor(formData) {
//     try {
//       const response = await api.post('customer/', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       return response;
//     } catch (error) {
//       console.error(error);
//     }
//   }

//loacalization

export async function countryList(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`localization/country/active/?id=${id}`);
      return response;
    } else {
      const response = await api.get("localization/country/active/", { params });
      return response;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function statelist(params = {}) {
  try {
    const response = await api.get("localization/state/active/", { params });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function PurchaseWarehouseAdd(formData) {
  console.log("Data", formData);
  try {
    const response = await api.post("purchases/warehouse/", formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

//GOODS-Receipt

export async function getGoodsReceipt(params = {}) {
  try {
    const response = await api.get("purchases/goods-receipts/", {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getGoodsReceiptDetails(uuid) {
  try {
    const response = await api.get(`purchases/goods-receipts/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CreateGoodsReceipt(formData) {
  try {
    const response = await api.post(
      "purchases/goods-receipts/create",
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function RemainingGoodsReceiptItems(purchase_uuid) {
  try {
    const response = await api.get(
      `purchases/goods-receipts/remaining-items/${purchase_uuid}/`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CreatePartialGoodsReceipt(formData) {
  try {
    const response = await api.post(
      "purchases/goods-receipts/create-partial",
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateReceivedQuantity(formData) {
  try {
    const response = await api.put(
      `purchases/goods-receipts/update-received-quantity/`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateGoodsReceipt(uuid, formData) {
  try {
    const response = await api.put(
      `purchases/goods-receipts/${uuid}/update/`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CancelGoodsReceipt(id) {
  try {
    const response = await api.post(`purchases/goods-receipts/${id}/cancel/`);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ArchiveGoodsReceipt(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("purchases/goods-receipts/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`purchases/goods-receipts/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteGoodsReceipt(uuid) {
  try {
    let response;
    if (Array.isArray(uuid)) {
      response = await api.delete(`purchases/goods-receipts/delete/?uuid=${uuid.join(',')}`);
    } else {
      response = await api.delete(`purchases/goods-receipts/${uuid}/delete/`);
    }
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message);
  }
}

export async function CheckGoodsReceiptExists(purchase_id) {
  try {
    const response = await api.get(`purchases/check-goods-receipt/`, {
      params: { purchase_id: purchase_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//PurchaseReturn

export async function getPurchaseReturns(params = {}) {
  try {
    const response = await api.get("purchases/return/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPurchaseReturnDetails(uuid) {
  try {
    const response = await api.get(`purchases/return/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CreatePurchaseReturn(formData) {
  try {
    const response = await api.post("purchases/return/create/", formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PurchaseReturnEdit(id, formData) {
  try {
    const response = await api.put(`purchases/return/?id=${id}`, formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function PurchaseReturnUpdate(uuid, formData) {
  try {
    const response = await api.put(
      `purchases/return/${uuid}/update/`,
      formData,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ConfirmPurchaseReturn(id) {
  try {
    const response = await api.post(`purchases/return/${id}/confirm/`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function CancelPurchaseReturn(id) {
  try {
    const response = await api.post(`purchases/return/${id}/cancel/`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function CheckPurchaseReturnStatus(purchase_return) {
  try {
    const response = await api.get(`purchases/return/status/`, {
      params: { purchase_return: purchase_return },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function InitiateGoodsReturn(purchase_return) {
  try {
    const response = await api.get(`purchases/goods-return/initiate/`, {
      params: { purchase_return_id: purchase_return },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ArchivePurchaseReturn(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("purchases/return/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`purchases/return/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PurchaseReturnDelete(id) {
  try {
    const response = await api.delete(`purchases/return/delete/?id=${Array.isArray(id) ? id.join(',') : id}`);
    return response;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function PurchaseReturnEditCheck(return_id) {
  try {
    const response = await api.get(`purchases/return/edit-check/`, {
      params: { id: return_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function DeliveredPurchaseOrders() {
  try {
    const response = await api.get("purchases/received/");
    const orders = response.data.data;

    return orders.map((order) => ({
      label: order.order_id,
      value: order.id,
    }));
  } catch (error) {
    // In production, avoid logging. Optionally use a toast or silent fail.
    return [];
  }
}

export async function CheckReturnablePurchaseProducts(purchase_id, exclude_return_id = null) {
  try {
    const params = { purchase_id: purchase_id };
    if (exclude_return_id) {
      params.exclude_return_id = exclude_return_id;
    }
    const response = await api.get(`purchases/returnable-products/`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function GetVendorReturnableOrders(vendor) {
  try {
    if (!vendor) return [];

    const response = await api.get("purchases/returns/returnable-orders/", {
      params: { vendor },
    });

    const orders = response.data?.data;

    return orders.map((order) => ({
      label: order.order_id,
      value: order.id,
    }));
  } catch (error) {
    throw error;
  }
}

export async function getGoodsReturns(params = {}) {
  try {
    const response = await api.get("purchases/goods-return/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getGoodsReturnDetails(uuid) {
  try {
    const response = await api.get(`purchases/goods-return/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CancelGoodsReturn(id) {
  try {
    const response = await api.post(`purchases/goods-return/${id}/cancel/`);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function MarkGoodsReturned(formData) {
  try {
    const response = await api.put(
      `purchases/returns/update-returned-quantity/`,
      formData,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function ArchiveGoodsReturn(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("purchases/goods-return/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`purchases/goods-return/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CreateGoodsReturn(formData) {
  try {
    const response = await api.post("purchases/goods-return/create/", formData);
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function DeleteGoodsReturn(id) {
  try {
    let response;
    if (Array.isArray(id)) {
      response = await api.delete(`purchases/goods-return/delete/?uuid=${id.join(',')}`);
    } else {
      response = await api.delete(`purchases/goods-return/${id}/delete/`);
    }
    return response;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export const getPurchaseItem = async (params) => {
  try {
    const response = await api.get(
      `reports/purchases-by-item/`, // ✅ FIXED
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching purchases by item:", error);
    throw error;
  }
};

export const getPurchaseItemDetail = async (item_id, params) => {
  try {
    const response = await api.get(`reports/purchases-by-item/${item_id}/`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase item detail:", error);
    throw error;
  }
};

export const getPurchaseVendor = async (params) => {
  try {
    const response = await api.get(
      `reports/purchases-by-vendor/`, // ✅ FIXED
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase by vendor:", error);
    throw error;
  }
};

export const getPurchaseVendorDetail = async (vendor_id, params) => {
  try {
    const response = await api.get(
      `reports/purchases-by-vendor/${vendor_id}/`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching purchase vendor detail:", error);
    throw error;
  }
};
export const downloadRFQPDF = async (uuid, params = {}) => {
  try {
    const response = await api.get(`purchases/rfqs/${uuid}/pdf/`, {
      params: { ...params, download: "true" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading RFQ PDF:", error);
    throw error;
  }
};

export const downloadPurchaseOrderPDF = async (uuid, params = {}) => {
  try {
    const response = await api.get(`purchases/purchase-orders/${uuid}/pdf/`, {
      params: { ...params, download: "true" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading Purchase Order PDF:", error);
    throw error;
  }
};

export const printPdf = async (apiCall, params = {}, ...args) => {
  try {
    const response = await apiCall(...args, params);

    // response itself is the Blob directly
    const blob = response instanceof Blob
      ? response
      : new Blob([response], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.cssText = "position:fixed; top:-10000px; left:-10000px; width:1px; height:1px;";
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          window.open(url, "_blank");
        } finally {
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(url);
          }, 1000);
        }
      }, 500);
    };

  } catch (error) {
    console.error("Print failed:", error);
  }
};
